exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userspage-cssmodule-userspage-component-2QmkZ{border:1px dashed red;border:none}", ""]);

// exports
exports.locals = {
	"userspage-component": "userspage-cssmodule-userspage-component-2QmkZ"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/Users/userspage.cssmodule.scss
// module id = 613
// module chunks = 0